import FooterAddress from '@root/joinroot.com/src/components/footer/footer-address';
import FooterLink from '@root/joinroot.com/src/components/footer/footer-link';
import FooterLinksColumn from '@root/joinroot.com/src/components/footer/footer-links-column';
import FooterLinksContainer from '@root/joinroot.com/src/components/footer/footer-links-container';
import React from '@root/vendor/react';
import Responsive from '@root/core/src/utils/responsive';
import environment from '@root/core/src/utils/environment';
import { Colors, StyleSheet } from '@root/core/src/utils/styles';

export default function DividedFooterLinks() {
  return (
    <>
      <FooterLinksContainer>
        <FooterLinksColumn columnStyles={styles.column}>
          <p css={styles.sectionHeading}>Coverage</p>
          <FooterLink
            linkText={'Get a quote'}
            url={environment.quoteAppBaseUrl}
          />
          <FooterLink
            isInternal
            linkText={'Auto'}
            url={'/coverage'}
          />
          <FooterLink
            isInternal
            linkText={'Renters'}
            url={'/renters-insurance'}
          />
          <FooterLink
            isInternal
            linkText={'Homeowners'}
            url={'/homeowners-insurance/'}
          />
        </FooterLinksColumn>
        <FooterLinksColumn columnStyles={styles.column}>
          <p css={styles.sectionHeading}>About us</p>
          <FooterLink
            isInternal
            linkText={'Our company'}
            url={'/company'}
          />
          <FooterLink
            isInternal
            linkText={'Customer reviews'}
            url={'/customer-reviews'}
          />
          <FooterLink
            linkText={'Careers'}
            url={'/careers'}
          />
          <FooterLink
            linkText={'Blog'}
            url={'/blog'}
          />
          <FooterLink
            isInternal
            linkText={'Press'}
            url={'/press'}
          />
        </FooterLinksColumn>
        <FooterLinksColumn columnStyles={styles.column}>
          <p css={styles.sectionHeading}>Contact us</p>
          <FooterLink
            isInternal
            linkText={'Customer support'}
            url={'/contact'}
          />
          <FooterLink
            isInternal
            linkText={'FAQ'}
            url={'/help'}
          />
          <FooterLink
            isInternal
            linkText={'Roadside assistance'}
            url={'/coverage/roadside-assistance'}
          />
        </FooterLinksColumn>
        <FooterLinksColumn columnStyles={styles.column}>
          <p css={styles.sectionHeading}>Claims</p>
          <FooterLink
            isInternal
            linkText={'File a claim'}
            url={'/claims'}
          />
        </FooterLinksColumn>
      </FooterLinksContainer>
      <div
        css={styles.divider}
        data-testid={'footer-divider'}
      />
      <FooterLinksContainer>
        <FooterLinksColumn columnStyles={styles.column}>
          <FooterLink
            isInternal
            linkText={'Coverage'}
            url={'/coverage'}
          />
          <FooterLink
            isInternal
            linkText={'Referrals'}
            url={'/referrals'}
          />
          <FooterLink
            isInternal
            linkText={'Affiliates'}
            url={'/affiliates'}
          />
          <FooterLink
            isInternal
            linkText={'Contact'}
            url={'/contact'}
          />
          <FooterLink
            isInternal
            linkText={'Meet our app'}
            url={'/mobile-app'}
          />
          <FooterLink
            isInternal
            linkText={'Test drive'}
            url={'/test-drive'}
          />
        </FooterLinksColumn>
        <FooterLinksColumn columnStyles={styles.column}>
          <FooterLink
            isInternal
            linkText={'Terms and conditions'}
            url={'/terms-and-conditions'}
          />
          <FooterLink
            isInternal
            linkText={'Privacy policy'}
            url={'/privacy-policy'}
          />
          <FooterLink
            isInternal
            linkText={'App license agreement'}
            url={'/app-eula'}
          />
          <FooterLink
            isInternal
            linkText={'Weather related events'}
            url={'/weather'}
          />
          <FooterLink
            isInternal
            linkText={'Non-weather emergencies'}
            url={'/non-weather'}
          />
          <FooterLink
            isInternal
            linkText={'Car insurance comparison'}
            url={'/car-insurance-comparison'}
          />
        </FooterLinksColumn>
        <FooterLinksColumn columnStyles={styles.column}>
          <FooterLink
            isInternal
            linkText={'Quote'}
            url={'/quote'}
          />
          <FooterLink
            linkText={'Discounts'}
            url={'/discounts'}
          />
          <FooterLink
            isInternal
            linkText={'Company'}
            url={'/company'}
          />
          <FooterLink
            linkText={'Careers'}
            url={'/careers'}
          />
          <FooterLink
            isInternal
            linkText={'Sitemap'}
            url={'/sitemap'}
          />
        </FooterLinksColumn>
        <FooterLinksColumn columnStyles={styles.column}>
          <FooterAddress />
        </FooterLinksColumn>
      </FooterLinksContainer>
    </>
  );
}

const styles = StyleSheet.create({
  column: {
    ...Responsive.md({
      flexBasis: '25%',
    }),
  },
  sectionHeading: {
    color: Colors.gray50(),
    marginBottom: 10,
  },
  divider: {
    margin: '55px 0',
    borderTop: `1px solid ${Colors.gray30()}`,
  },
});
